import { render, staticRenderFns } from "./JSelectDictKwgl.vue?vue&type=template&id=75dbada9&scoped=true"
import script from "./JSelectDictKwgl.vue?vue&type=script&lang=js"
export * from "./JSelectDictKwgl.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75dbada9",
  null
  
)

export default component.exports